import EditAutomationSelectHeader from './EditAutomationSelectHeader';

export default EditAutomationSelectHeader;
